import { createContext, useState } from 'react';

export const ChatAudioContext = createContext();

const ChatAudioProvider = ({ children }) => {
  const [currentAudio, setCurrentAudio] = useState(null);

  return (
    <ChatAudioContext.Provider value={{ currentAudio, setCurrentAudio }}>
      {children}
    </ChatAudioContext.Provider>
  );
};

export default ChatAudioProvider;
